import { stringify } from 'query-string'
import { API_CRM_BASE_URL, API_TIMEOUT } from 'shared/constants/defaultENV'

import { Api } from './ApiGlobals'

const CrmApi = new Api({
  baseURL: API_CRM_BASE_URL,
  timeout: API_TIMEOUT,
})

CrmApi.instance.defaults.paramsSerializer = function (params) {
  return stringify(params)
}

export default CrmApi
